export { CENTER_RADIUS } from '@s4l/stayforlong/property/schemas/v3/search/legacy'
